import styled, {keyframes} from "styled-components";
import {ColorButton, ColorButtonProps} from "./color-button";
import {IconProps} from "../model";
import {ModalWrapper} from "./modal-wrapper";


interface ActionModalProps extends ColorButtonProps {
    title: string;
    open: boolean;
    onClose?: () => void;
    children?: React.ReactNode;
    subText?: string;

}

export const ActionModal = ({open, subText, onClose, title, onClick, text, children, variant}: ActionModalProps) => {

    if (!open) return null;

    return (
        <ModalWrapper>
            {onClose &&
                <CLoseIcon onClick={onClose}/>
            }
            <Container>
                <Title>
                    {title}
                </Title>
                <SubTitle>
                    {subText}
                </SubTitle>
                {children}
                <ColorButton
                    variant={variant}
                    onClick={onClick} text={text}/>
            </Container>
        </ModalWrapper>
    )
}


const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: scale(0.8);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
`;


const SubTitle = styled.div`
    color: #FFE600;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%; /* 20.8px */
    text-transform: uppercase;
`


const Title = styled.div`
    color: #E0E000;
    text-align: center;
    text-shadow: 0px 4px 8px rgba(255, 255, 0, 0.50);
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: #000;
    font-size: 26px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 24px */
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-top: 10%;
`


const Container = styled.div`
    display: flex;
    padding: 0px 28px 32px 28px;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    animation: ${fadeIn} 0.3s ease-in-out;
    position: relative;
    box-sizing: border-box;
    gap: 16px;

`


const CloseIconSWG = (props: IconProps) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M3.29289 3.29289C3.68342 2.90237 4.31658 2.90237 4.70711 3.29289L10 8.58579L15.2929 3.29289C15.6834 2.90237 16.3166 2.90237 16.7071 3.29289C17.0976 3.68342 17.0976 4.31658 16.7071 4.70711L11.4142 10L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L10 11.4142L4.70711 16.7071C4.31658 17.0976 3.68342 17.0976 3.29289 16.7071C2.90237 16.3166 2.90237 15.6834 3.29289 15.2929L8.58579 10L3.29289 4.70711C2.90237 4.31658 2.90237 3.68342 3.29289 3.29289Z"
                  fill="white"/>
        </svg>
    )
}


const CLoseIcon = styled(CloseIconSWG)`
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
    z-index: 1;
`


